/**
 * Milk quality threshold constants and helpers.
 *
 * Values in the database are stored in thousands:
 *   SCC 200 = 200,000 cells/ml
 *   TBC  20 =  20,000 cfu/ml
 */

export const SCC_THRESHOLDS = { good: 200, warning: 400 } as const;
export const TBC_THRESHOLDS = { good: 20, warning: 100 } as const;

export const ZONE_COLORS = {
  green: "#4CAF50",
  amber: "#FF9800",
  red: "#F44336",
} as const;

export type Zone = "green" | "amber" | "red";

export function getSccZone(scc: number): Zone {
  if (scc < SCC_THRESHOLDS.good) return "green";
  if (scc < SCC_THRESHOLDS.warning) return "amber";
  return "red";
}

export function getTbcZone(tbc: number): Zone {
  if (tbc < TBC_THRESHOLDS.good) return "green";
  if (tbc < TBC_THRESHOLDS.warning) return "amber";
  return "red";
}

export function getZoneColor(zone: Zone): string {
  return ZONE_COLORS[zone];
}
